import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { connect } from 'react-redux';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { Add } from '@material-ui/icons';
import { IMG_FILE_ICON } from 'images';
import { jobTitles } from 'controllers/taxonomies';
import { AutoSuggest } from '../../common';
import { updateJob } from 'controllers/job';

const useStyles = makeStyles((theme) => ({
  root: {
    color: '#ffffff',
    background: '#49515a',
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  modal: {
    background: '#ffffff',
    maxWidth: '888px',
    margin: '66px auto 0',
    padding: '1px',
    height: 'calc(100vh - 132px)',
    overflow: 'auto',
  },
}));

function NavigationMenu(props) {
  const classes = useStyles();
  const [showMenu, setShowMenu] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const anchorRef = React.useRef(null);
  const { errorFlag, jobRole } = props;

  const changeLocation = (location) => () => {
    const { history } = props;
    history.push(location);
  };

  const fetchJobTitles = async (value) => {
    const titles = await jobTitles(value);
    return await titles.response.map((title) => title['job title']);
  };

  const handleToggle = () => {
    setShowMenu((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    setShowMenu(false);
  };

  const handleModalOpen = () => {
    // setShowModal(true);
    // setShowMenu(false);
    changeLocation('/create-job')();
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const onUpdateJobHandler = (e) => {
    if (e.target.name) {
      updateJob({
        [e.target.name]: e.target.value,
      });
    }
  };

  const onSelectJobRole = (e, value) => {
    const { history } = props;
    updateJob({
      jobRole: value.suggestion,
    });
    history.push('/create-job');
  };

  return (
    <div>
      <div>
        <IconButton
          ref={anchorRef}
          aria-controls={showMenu ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <Add />
        </IconButton>
        <Popper
          open={showMenu}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={showMenu}
                    id="menu-list-grow"
                    classes={classes}
                  >
                    <MenuItem onClick={handleModalOpen}>
                      <img
                        src={IMG_FILE_ICON}
                        style={{ marginRight: '10px' }}
                        alt=""
                      />
                      Create Job
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
      <Modal
        open={showModal}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        classes={classes.modal}
      >
        <div className={classes.modal}>
          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                padding: '18px',
                borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                position: 'relative',
              }}
            >
              <Typography variant="h6">Create new Job descreption</Typography>
              <IconButton
                onClick={handleModalClose}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                }}
              >
                <CloseIcon></CloseIcon>
              </IconButton>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                padding: '18px',
                borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
              }}
            >
              <Typography variant="h6" gutterBottom>
                Create from Scratch
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={changeLocation('/create-job')}
              >
                CREATE
              </Button>
            </Grid>
            <Grid item xs={12} style={{ padding: '18px' }}>
              <Typography variant="h6" gutterBottom>
                Create from previous Job Decreptions
              </Typography>
              <Typography variant="body2" gutterBottom>
                Select the Job description from the list of previously create
                and tailor it to suit your current requirement.
              </Typography>
              <AutoSuggest
                placeholder={'Job Title ( required )'}
                value={jobRole}
                name="jobRole"
                onChange={onUpdateJobHandler}
                fetchSuggestions={fetchJobTitles}
                onSelect={onSelectJobRole}
                errorFlag={errorFlag && !jobRole}
                errorMessage="This field is required."
              />
            </Grid>
          </Grid>
        </div>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  const { selectedJob } = state.job;
  return {
    ...selectedJob,
  };
};

export default connect(mapStateToProps, null)(NavigationMenu);
